import {Button, Col, message, Row, Space} from "antd";
import {useCreateProductContext} from "../../context/create-product";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {ProductCoverImagesFormFields} from "../../../../../components/offering-form/products/cover-images";
import {
  useProductUploadCoverImages,
  useProductCoverImagesDelete,
  useCoverImagesWithFallback,
  mapDomainToEmbedded,
} from "../../../../../features/media";
import {FullPageLoader} from "../../../../../components/full-page-loader";
import {OfferingFormAccordionItem} from "../../../../../components/offering-form/accordion/accordion-item";

/**
 * By the time this step is reached, the product was already created via
 * the basicForm step, so `apiResponseData` always carries a real v2
 * digital-product id here — no need to re-fetch it.
 */
export function CreateProductCoverImagesUploadStep() {
  const productUploadCoverImagesMutation = useProductUploadCoverImages();
  const productCoverImagesDeleteMutation = useProductCoverImagesDelete();
  const {
    dispatch,
    state: {formData, apiResponseData},
  } = useCreateProductContext();

  const productId = apiResponseData?.product?.id;

  // v2 cover images fetch with embedded fallback
  const {coverImages, isLoading: isCoverImagesLoading} = useCoverImagesWithFallback({
    offeringType: "product",
    offeringId: productId,
    embedded: apiResponseData?.product?.cover_images,
  });
  const coverImagesForDisplay = mapDomainToEmbedded(coverImages);

  if (isCoverImagesLoading) {
    return <FullPageLoader />;
  }

  function handleCoverImagesItemDelete({
    mediaId,
    offeringId,
  }: {
    mediaId: string;
    offeringId: number;
  }) {
    productCoverImagesDeleteMutation.mutate(
      {mediaId, productId: offeringId},
      {
        onSuccess: () => {
          message.success("Deleted successfully");
        },
      }
    );
  }

  function handleNextStep() {
    dispatch({
      type: "update-create-product-form-step",
      payload: "contentUpload",
    });
  }

  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <OfferingFormAccordionItem key={"Cover image"} index={0} title={"Cover image"}>
          <ProductCoverImagesFormFields
            accordionIndex={0}
            productData={{
              id: productId ?? 0,
            }}
            defaultCoverImages={coverImagesForDisplay}
            deleteCoverImage={handleCoverImagesItemDelete}
            isDeleteLoading={productCoverImagesDeleteMutation.isLoading}
            isUploadLoading={productUploadCoverImagesMutation.isLoading}
            offeringId={productId ?? 0}
            uploadCoverImages={productUploadCoverImagesMutation}
          />
        </OfferingFormAccordionItem>
        <Row gutter={[0, 16]}>
          <Col span={24} sm={12}>
            <StyledServiceButtonWrapper>
              <Button
                className="secondary-btn"
                onClick={() =>
                  dispatch({
                    type: "update-create-product-form-step",
                    payload: "basicForm",
                  })
                }
                block
                size="small"
                type="default"
              >
                Back
              </Button>
              <Button
                block
                type="primary"
                size="small"
                onClick={handleNextStep}
                disabled={
                  productUploadCoverImagesMutation.isLoading ||
                  productCoverImagesDeleteMutation.isLoading ||
                  coverImages.length < 1
                }
              >
                Next
              </Button>
            </StyledServiceButtonWrapper>
          </Col>
        </Row>
      </Space>
    </div>
  );
}
